import React from 'react';
import PropTypes from 'prop-types';

import Form from '../../../../components/Form';
import Input from '../../../../components/Input';
import ErrorLabel from '../components/ErrorLabel';
import basicInfoMessages from '../messages';
import '../styles.css';

export function GraduationRate4year({ onChange, initialValue }) {
  return (
    <Form.Field styleName="field">
      <Input
        fluid
        name="graduationRate4"
        pattern="([0-9]{1,2}?|100)"
        type="number"
        min="0"
        max="100"
        maxLength="3"
        value={initialValue.value}
        onChange={(e, { value }) => {
          onChange(e, { value });
        }}
        error={initialValue.showError}
      />
      {initialValue.showError && <ErrorLabel error={{ ...basicInfoMessages.invalidError }} />}
    </Form.Field>
  );
}

GraduationRate4year.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export function GraduationRate6year({ onChange, initialValue }) {
  return (
    <Form.Field styleName="field">
      <Input
        fluid
        name="graduationRate6"
        pattern="([0-9]{1,2}?|100)"
        type="number"
        min="0"
        max="100"
        maxLength="3"
        value={initialValue.value}
        onChange={(e, { value }) => {
          onChange(e, { value });
        }}
        error={initialValue.showError}
      />
      {initialValue.showError && <ErrorLabel error={{ ...basicInfoMessages.invalidError }} />}
    </Form.Field>
  );
}

GraduationRate6year.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};
